document.addEventListener("DOMContentLoaded", function () {
    // Get the span element with the metafield date
    var dateElement = document.getElementById("product-metafield-date");
    if (dateElement) {
        // Retrieve the metafield value from the data attribute
        var metafieldDateString = dateElement.getAttribute("data-delivery-date");

        // Remove "Delay: " prefix if it exists
        if (metafieldDateString.startsWith("Delay:")) {
            metafieldDateString = metafieldDateString.slice(6).trim(); // Remove "Delay: " and trim spaces
        }

        // Function to get the ordinal suffix (e.g., "ST", "ND", "RD", "TH")
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return "TH"; // Covers 11th to 20th
            switch (day % 10) {
                case 1:
                    return "ST";
                case 2:
                    return "ND";
                case 3:
                    return "RD";
                default:
                    return "TH";
            }
        }

        // Function to format the date string
        function formatDateString(dateString) {
            var regex = /^(\d{1,2})([a-zA-Z]+)(\d{4})$/;
            var match = dateString.match(regex);

            if (match) {
                var day = parseInt(match[1], 10); // Parse day as integer
                var month = match[2].toUpperCase(); // Convert month to uppercase
                var year = match[3];

                // Add ordinal suffix to the day
                var dayWithSuffix = day + getOrdinalSuffix(day);

                // Return formatted date
                return `${month} ${dayWithSuffix}`;
            }

            // Return the original string if it doesn't match the expected format
            return dateString;
        }

        // Format the metafield date
        var formattedDate = formatDateString(metafieldDateString);
        console.log("Formatted Date:", formattedDate);

        // Update the DOM element with the formatted date
        dateElement.textContent = "DELIVERY FROM " + formattedDate;
    }
});
